type TEnumObject = Record<string, string | number>;

/**
 * Values of a TypeScript enum or generated `api.enum` table. Numeric enums also carry reverse-mapped entries
 * (`EFoo[0] === 'BAR'`); those are keyed by the number and skipped here.
 */
export const getEnumValues = <T extends TEnumObject>(enumObject: T): T[keyof T][] =>
  Object.entries(enumObject)
    .filter(([key]) => Number.isNaN(Number(key)))
    .map(([, value]) => value as T[keyof T]);

/** Narrows an untyped value (route/query param, localStorage, config) to a member of the given enum. */
export const isEnumValue = <T extends TEnumObject>(enumObject: T, value: unknown): value is T[keyof T] =>
  getEnumValues(enumObject).includes(value as T[keyof T]);

/** Returns the value as enum member, or `undefined` when it is not one of the enum's values. */
export const parseEnum = <T extends TEnumObject>(enumObject: T, value: unknown): T[keyof T] | undefined =>
  isEnumValue(enumObject, value) ? value : undefined;
